import { handleResponse, handleError } from "./apiUtils";
const baseUrl = process.env.REACT_APP_API_SERVER_URL + "/api/event";

export function getCities() {
  return fetch(baseUrl + "/cities")
    .then(handleResponse)
    .catch(handleError);
}

export function getCategories() {
  return fetch(baseUrl + "/category")
    .then(handleResponse)
    .catch(handleError);
}

export function addCategory(accessToken, category) {
  return fetch(baseUrl + "/category", {
    method: "POST",
    headers: {
      "content-type": "application/json",
      Authorization: "Bearer " + accessToken
    },
    body: JSON.stringify(category)
  })
    .then(handleResponse)
    .catch(handleError);
}

export function getUnapprovedCategories(accessToken) {
  return fetch(baseUrl + "/category/unapproved", {
    headers: {
      Authorization: "Bearer " + accessToken
    }
  })
    .then(handleResponse)
    .catch(handleError);
}

export function approveCategory(accessToken, id) {
  return fetch(baseUrl + "/category/approve?id=" + id, {
    method: "PUT",
    headers: {
      Authorization: "Bearer " + accessToken
    }
  })
    .then(handleResponse)
    .catch(handleError);
}

export function rejectCategory(accessToken, id) {
  return fetch(baseUrl + "/category/reject?id=" + id, {
    method: "DELETE",
    headers: {
      Authorization: "Bearer " + accessToken
    }
  })
    .then(handleResponse)
    .catch(handleError);
}

export function getTargetGroups() {
  return fetch(baseUrl + "/targetgroup")
    .then(handleResponse)
    .catch(handleError);
}

export function addTargetGroup(accessToken, targetGroup) {
  console.log(targetGroup);
  return fetch(baseUrl + "/targetgroup", {
    method: "POST",
    headers: {
      "content-type": "application/json",
      Authorization: "Bearer " + accessToken
    },
    body: JSON.stringify(targetGroup)
  })
    .then(handleResponse)
    .catch(handleError);
}

export function getUnapprovedTargetGroups(accessToken) {
  return fetch(baseUrl + "/targetgroup/unapproved", {
    headers: {
      Authorization: "Bearer " + accessToken
    }
  })
    .then(handleResponse)
    .catch(handleError);
}

export function approveTargetGroup(accessToken, id) {
  return fetch(baseUrl + "/targetgroup/approve?id=" + id, {
    method: "PUT",
    headers: {
      Authorization: "Bearer " + accessToken
    }
  })
    .then(handleResponse)
    .catch(handleError);
}

export function rejectTargetGroup(accessToken, id) {
  return fetch(baseUrl + "/targetgroup/reject?id=" + id, {
    method: "DELETE",
    headers: {
      Authorization: "Bearer " + accessToken
    }
  })
    .then(handleResponse)
    .catch(handleError);
}

export function getFoods() {
  return fetch(baseUrl + "/food")
    .then(handleResponse)
    .catch(handleError);
}

export function getFoodCost() {
  return fetch(baseUrl + "/foodcost")
    .then(handleResponse)
    .catch(handleError);
}
